
import React, { useEffect, useState } from 'react'
import { Input, Space, Table } from 'antd'
import axios from 'axios'
import { useLocation } from 'react-router-dom';
import AdminProfile from './AdminProfile';
import NewTransactionTable from './NewTransactionTable';
import SwipeableViews from 'react-swipeable-views';
import Api from './Api';
import BOT from './BOT';
const { Search } = Input;


const ViewfilterApiBot = (props) => {
  const [filter, setFilter] = useState("ALL");
  const [index, setIndex] = useState(0);

  const {userDetails } = props;

  const handleChangeIndex = (tabIndex) => {
    setIndex(tabIndex);
  
    if (tabIndex === 1) {
      setFilter("SPOT");
    }
  };

  const handleFilterClick = (filterType) => {
    setFilter(filterType);
  };
 

  const tabs = ["API", "BOT"];

  return (
    <div className=''>
      <div>
        <div className="flex justify-between items-center">
          <div className="flex justify-start flex-col items-start lg:space-x-4 ">
            <div className="p-2 ">
              <div className="flex mb-4 items-center justify-end">
              {index !== 1 && (
                <button
                  className={`mr-2 2xl:px-4 py-1 rounded-full w-20 2xl:w-24 shadow-md drop-shadow-xl ${filter === "ALL"
                    ? "bg-colorSecondaryDark text-white border-2 border-white "
                    : "bg-white text-colorSecondaryDark"
                    }`}
                  onClick={() => {
                    handleFilterClick("ALL");
                    setFilter("ALL");
                  }}
                >
                  All
                </button>
                  )}
                <button
                  className={`mr-2 2xl:px-4 py-1 rounded-full w-20 2xl:w-24 shadow-md ${filter === "SPOT"
                    ? "bg-colorSecondaryDark text-white border-2 border-white drop-shadow-xl"
                    : "bg-white text-colorSecondaryDark"
                    }`}
                  onClick={() => {
                    handleFilterClick("SPOT");
                    setFilter("SPOT");
                  }}
                >
                  Spot
                </button>
                <button
                  className={`mr-2 xl:px-4 py-1 rounded-full w-20 2xl:w-24 shadow-md ${filter === "FUTURES"
                    ? "bg-colorSecondaryDark text-white border-2 border-white drop-shadow-xl"
                    : "bg-white text-colorSecondaryDark"
                    }`}
                  onClick={() => {
                    handleFilterClick("FUTURES");
                    setFilter("FUTURES");
                  }}
                >
                  Futures
                </button>
              </div>
            </div>
          </div>


          <div>
          <div className="mx-auto my-6 rounded-md">
                <div className="flex items-center h-full transform translate-x-0 translate-y-0">
                  <div className="grid grid-cols-2  gap-4 w-full">
                    {tabs.map((tab, tabIndex) => (
                      <div
                        key={tabIndex}
                        className={`px-5 py-1 font-medium rounded-xl top-left-shadow  text-center cursor-pointer ${index === tabIndex
                            ? "active-tab bg-colorAccent shadow-neumorphic  text-white rounded-3xl "
                            : "text-black border-none"
                          }`}
                        onClick={() => handleChangeIndex(tabIndex)}
                      >
                        {tab}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
          </div>

        </div>
      </div>

      {
        <div className="">
          <div className="">
            <SwipeableViews
              index={index}
              onChangeIndex={handleChangeIndex}
              className=" mx-4 "
            >
              <div>
                <Api userName={userDetails?.Username} filter={filter} />
              </div>
              <div>
                <BOT userName={userDetails?.Username} filter={filter} />
              </div>
            </SwipeableViews>
          </div>
        </div>
      }
    </div>
  )
}

export default ViewfilterApiBot
